import {BaseCachedService} from './Core/BaseCachedService';

class SurveySubmissionStatusService extends BaseCachedService {
    get Url() { return super.Url + "/surveySubmissionStatuses"; }
    get ModelName() { return "Survey Submission Status"; }
    get PrimaryKeyProperty() { return "surveySubmissionStatusId"; }
    get TitleProperty() { return "name"; }
}

export const service = new SurveySubmissionStatusService();
